import { render } from "./AboutView.vue?vue&type=template&id=5900e788&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=5900e788&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5900e788"]])

export default __exports__